import React from 'react'

// Reihenfolge der Zahlen im Uhrzeigersinn, oben beginnend
const ZAHLEN = [20, 1, 18, 4, 13, 6, 10, 15, 2, 17, 3, 19, 7, 16, 8, 11, 14, 9, 12, 5];

const FARBE_HELL = "#efe3c4";
const FARBE_DUNKEL = "#161616";
const FARBE_ROT = "#d42a2f";
const FARBE_GRUEN = "#1f8f55";

function punkt(radius, winkelGrad) {
    const rad = (winkelGrad - 90) * Math.PI / 180;
    return [radius * Math.cos(rad), radius * Math.sin(rad)];
}

function ringSegment(innen, aussen, start, ende) {
    const [x1, y1] = punkt(aussen, start);
    const [x2, y2] = punkt(aussen, ende);
    const [x3, y3] = punkt(innen, ende);
    const [x4, y4] = punkt(innen, start);
    return `M${x1} ${y1} A${aussen} ${aussen} 0 0 1 ${x2} ${y2} L${x3} ${y3} A${innen} ${innen} 0 0 0 ${x4} ${y4}Z`;
}

/**
 * Rein dekoratives Dartboard (SVG) für die Startseite. Maße angelehnt an ein echtes Steeldartboard.
 */
export default function StartseiteDartboard({className}) {
    const segmente = [];
    ZAHLEN.forEach((zahl, index) => {
        const start = index * 18 - 9;
        const ende = start + 18;
        const gerade = index % 2 === 0;
        const single = gerade ? FARBE_DUNKEL : FARBE_HELL;
        const ring = gerade ? FARBE_ROT : FARBE_GRUEN;
        segmente.push(<path key={"d" + zahl} d={ringSegment(162, 170, start, ende)} fill={ring}/>);
        segmente.push(<path key={"so" + zahl} d={ringSegment(107, 162, start, ende)} fill={single}/>);
        segmente.push(<path key={"t" + zahl} d={ringSegment(99, 107, start, ende)} fill={ring}/>);
        segmente.push(<path key={"si" + zahl} d={ringSegment(16, 99, start, ende)} fill={single}/>);
        const [x, y] = punkt(190, index * 18);
        segmente.push(<text key={"z" + zahl} x={x} y={y} className="dhs-board-zahl" textAnchor="middle" dominantBaseline="central">{zahl}</text>);
    });

    const draehte = [];
    for (let i = 0; i < 20; i++) {
        const [x1, y1] = punkt(16, i * 18 - 9);
        const [x2, y2] = punkt(170, i * 18 - 9);
        draehte.push(<line key={"w" + i} x1={x1} y1={y1} x2={x2} y2={y2}/>);
    }

    return <svg className={className} viewBox="-215 -215 430 430" aria-hidden="true" focusable="false">
        <circle r="214" fill="#0b0b0b"/>
        <circle r="212" fill="none" stroke="#2a2a2a" strokeWidth="2"/>
        {segmente}
        <circle r="16" fill={FARBE_GRUEN}/>
        <circle r="6.35" fill={FARBE_ROT}/>
        <g className="dhs-board-draht">
            {draehte}
            {[6.35, 16, 99, 107, 162, 170].map(r => <circle key={"r" + r} r={r} fill="none"/>)}
        </g>
    </svg>
}
